// extracted by mini-css-extract-plugin
export default {"container":"CreateJobPrivateNotesTab_container__aZsvt","title":"CreateJobPrivateNotesTab_title__GRt7G","formFooter":"CreateJobPrivateNotesTab_formFooter__ExdfI"};